import React, { useState } from 'react'
import { Checkbox } from "antd"

import Modal from "../resusable/modal"

import { usePet, useToggle } from '../../modules'
import pluralize from 'pluralize'

const EditItem = ({ toggle, visible, record, onPerform }) => {
    const [bulk, setBulk] = useState(record?.bulkCount ?? 1)
    const [contains, setContains] = useState(record?.containing ?? 0)
    const [bp, setBp] = useState(record?.bp ?? 1)
    const [discount, setDiscount] = useState(record?.discount ?? 0)
    const [vat, setVat] = useState(record?.vat ?? 16)

    const [singles, toggleSingles] = useToggle()
    const [perc, togglePerc] = useToggle()
    const [priceBulk, togglePriceBulk] = useToggle()

    const modify = e => {
        switch (e.target.name) {
            case 'bulk':
                setBulk(e.target.value)
                break
                
            case 'contains':
                setContains(e.target.value)
                break

            case 'bp':
                setBp(e.target.value)
                break

            case 'discount':
                setDiscount(e.target.value)
                break
                
            case 'vat':
                setVat(e.target.value)
                break

            default:
                break
        }
    }

    return (
        <Modal
            h="h-auto"
            w="w-1/4"
            title="Edit Item"
            toggle={toggle}
            visible={visible}>
            <Checkbox checked={ singles } onChange={ () => {
                setBulk(1)
                toggleSingles()
            } }>Items arrived in { record?.item?.issuedIn?.toLowerCase() }</Checkbox>
            <div className="flex flex-wrap mt-3">
            {
                !singles &&
                    <div className="w-full px-3 mb-6 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            How many { record?.item?.receivedIn}?
                        </label>
                        <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="grid-bulk"
                            name="bulk"
                            value={ bulk }
                            onChange={ modify }
                            type="number"
                            placeholder="50" />
                    </div>
            }
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        How many { record?.item?.issuedIn}?
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-contains"
                        type="number"
                        name="contains"
                        value={ contains }
                        onChange={ modify }
                        placeholder="100" />
                    <p className="text-gray-500 text-xs italic">How many { record?.item?.issuedIn?.toLowerCase()} { singles ? 'were received' : `does each ${ record?.item?.receivedIn && pluralize.singular(record?.item?.receivedIn?.toLowerCase()) } contain` }?</p>
                </div>
                <Checkbox checked={ priceBulk } onChange={ () => {
                    togglePriceBulk()
                } }>Price is given per { pluralize.singular(priceBulk ? record?.item?.issuedIn?.toLowerCase() : record?.item?.receivedIn?.toLowerCase()) }</Checkbox>   
                <div className="w-full my-2 px-3 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Unit Price
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-bp"
                        type="number"
                        name="bp"
                        value={ bp }
                        onChange={ modify }
                        placeholder="Ksh XXX" />
                </div>
                <Checkbox checked={ perc } onChange={ () => {
                    togglePerc()
                } }>Discount given as percentage</Checkbox>   
                <div className="w-full my-2 px-3 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Discount
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-discount"
                        type="number"
                        name="discount"
                        value={ discount }
                        onChange={ modify }
                        placeholder="14" />
                    <p className="text-gray-500 text-xs italic">Discount as { perc ? 'percentage %' : 'amount' }</p>
                </div>
                <div className="w-full px-3 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        VAT
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-vat"
                        type="number"
                        name="vat"
                        value={ vat }
                        onChange={ modify }
                        placeholder="16%" />
                </div>
            </div>
            <div className="flex justify-end mt-3">
                <button onClick={ () => {
                    toggle()
                    setTimeout(() => onPerform({
                        label: record.label,
                        value: record.value,
                        name: record.label,
                        _id: record._id,
                        bulk,
                        contains,
                        bp: priceBulk ? (bp / contains) : bp,
                        discount: priceBulk ? (perc ? bp * (discount/100) : discount) / contains : (perc ? bp * (discount/100) : discount),
                        vat
                    }), 300)
                } } className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default EditItem